// extracted by mini-css-extract-plugin
module.exports = {"grid":"VirtualShipmentTable_grid__11-Vp","row":"VirtualShipmentTable_row__3OMG_","cell":"VirtualShipmentTable_cell__2ru98","address":"VirtualShipmentTable_address__3SS-m"};